<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>เกมทั้งหมด</h6>
    </div>

    <!-- ส่วนค้นหา -->
    <div class="row mb-3 px-3">
      <div class="col-12 col-md-6 mb-2">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="ค้นหา Game Code หรือ ชื่อเกมส์..."
          class="form-control"
        />
      </div>
    </div>

    <!-- ตาราง -->
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-1">
          <thead>
            <tr class="text-center">
              <th>No.</th>
              <th @click="sort('code')">
                Game Code {{ sortBy === "code" ? "▼" : "▲" }}
              </th>
              <th @click="sort('name')">
                ชื่อเกมส์ {{ sortBy === "name" ? "▼" : "▲" }}
              </th>
              <th @click="sort('active')">
                Active {{ sortBy === "active" ? "▼" : "▲" }}
              </th>
            </tr>
          </thead>
          <tbody
            v-if="displayedData.length > 0"
            style="text-align-last: center"
          >
            <tr v-for="(item, index) in displayedData" :key="item.code">
              <td>{{ index + 1 + startRow }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td>
                <input
                  type="checkbox"
                  :checked="item.active"
                  @change="toggleActive(item)"
                  :disabled="role !== 'admin' || isLoading"
                  style="transform: scale(1.2); cursor: pointer"
                />
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7" class="text-center">ไม่พบข้อมูล</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  name: "GameListTable",
  data() {
    return {
      searchQuery: "",
      sortBy: "name",
      sortOrder: 1,
      startRow: 0,
      rowsPerPage: 100,
      currentPage: 1,
      data: [],
      allGame: [],
      isLoading: false,
      role: "",
      excludedCodes: [],
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
  },
  created() {
    this.getData();
    this.fetchUserRole();
  },
  computed: {
    filteredData() {
      const search = this.searchQuery.toLowerCase().trim();
      const excludedCodes = ["G005", "G006"]; // 👉 โค้ดที่ต้องซ่อนไม่ให้แสดง

      return this.data.filter((item) => {
        const matchesSearch =
          item.code?.toLowerCase().includes(search) ||
          item.name?.toLowerCase().includes(search) ||
          item.active?.toString().toLowerCase().includes(search);

        const notExcluded = !excludedCodes.includes(item.code);

        return notExcluded && (!search || matchesSearch);
      });
    },
    displayedData() {
      return this.filteredData.slice(
        this.startRow,
        this.startRow + this.rowsPerPage
      );
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.rowsPerPage);
    },
  },
  methods: {
    sort(sortBy) {
      if (this.sortBy === sortBy) {
        this.sortOrder = -this.sortOrder;
      } else {
        this.sortBy = sortBy;
        this.sortOrder = 1;
      }
      this.data.sort((a, b) => {
        if (a[sortBy] > b[sortBy]) return this.sortOrder;
        if (a[sortBy] < b[sortBy]) return -this.sortOrder;
        return 0;
      });
    },
    getData() {
      this.isLoading = true;
      axios
        .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/gamelistprod`)
        .then((response) => {
          this.data = response.data.data.sort((a, b) =>
            a.code.localeCompare(b.code)
          );
          this.allGame = this.data;
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
          Swal.fire({
            icon: "error",
            title: "ไม่สามารถดึงข้อมูลได้",
            text:
              e.response?.data?.responseStatus?.message ||
              e.message ||
              "Unknown error",
          });
          this.isLoading = false;
        });
      this.currentPage = 1;
      this.startRow = 0;
    },
    fetchUserRole() {
      axios
        .get(
          "https://dashboard-api.linkstudio.io/api/v1/game/control/users/me",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          this.role = res.data.data.role || "";
        })
        .catch((e) => {
          console.log(e);
          Swal.fire({
            icon: "error",
            title: "ไม่สามารถระบุสิทธิ์ผู้ใช้ได้",
            text: "กรุณาเข้าสู่ระบบใหม่",
          }).then(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            localStorage.removeItem("username");
            localStorage.removeItem("lastActivity");
            this.$router.push("/signin");
          });
          this.role = "";
        });
    },
    toggleActive(item) {
      const previousStatus = item.active; // บันทึกค่าสุดเดิม
      const newStatus = !item.active; // ค่าที่ผู้ใช้คลิก

      // เปลี่ยนสถานะชั่วคราวเพื่อให้ checkbox แสดงผลตามการคลิก
      item.active = newStatus;

      Swal.fire({
        title: `ต้องการเปลี่ยนสถานะของ "${item.code} ${item.name}" ใช่หรือไม่?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          axios
            .patch(
              `https://dashboard-api.linkstudio.io/api/v1/game/control/gamelistprod/${item.code}`,
              { active: newStatus }
            )
            .then((res) => {
              Swal.fire({
                icon: "success",
                title: "อัปเดตสำเร็จ",
                text: res.data.message || "อัปเดตสถานะสำเร็จ",
              });
              this.getData(); // ดึงข้อมูลใหม่
            })
            .catch((err) => {
              console.error(err);
              Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: err.response?.data?.message || "ไม่สามารถอัปเดตสถานะได้",
              });
              // ย้อนกลับค่าเดิม เพราะอัปเดตไม่สำเร็จ
              item.active = previousStatus;
            })
            .finally(() => {
              this.isLoading = false;
            });
        } else {
          // ❌ ถ้าผู้ใช้กดยกเลิก -> ย้อนค่า checkbox กลับไปเป็นค่าก่อนหน้า
          item.active = previousStatus;
        }
      });
    },
  },
};
</script>

<style scoped>
@media (max-width: 576px) {
  input.form-control {
    font-size: 0.9rem;
  }
  .table th,
  .table td {
    font-size: 0.85rem;
    padding: 0.3rem 0.5rem;
  }
}
</style>
